import React from 'react';

const PaymentLogos = () => {
  return (
    <div className="space-y-6">
      {/* PayTR logo section */}

          {/* Payment method logos */}
          <div className="flex justify-center items-center gap-6 mt-6">

      <p className="text-sm text-gray-400 text-center">
        Ödeme PayTR güvencesiyle alınır
      </p>
      </div>
      {/* Payment method logos */}
      <div className="flex justify-center items-center gap-6 mt-6">


      <img 
          src="/images/payment/paytr.jpg" 
          alt="PayTR Güvenli Ödeme" 
          className="h-12 object-contain"
        />
        <img 
          src="/images/payment/visa.jpg" 
          alt="Visa" 
          className="h-12 object-contain"
        />
        <img 
          src="/images/payment/mastercard.jpg" 
          alt="Mastercard" 
          className="h-12 object-contain"
        />
        <img 
          src="/images/payment/troy.jpg" 
          alt="Troy" 
          className="h-12 object-contain"
        />
      </div>

 
    </div>
  );
};

export default PaymentLogos;